import { useConsole } from "contexts/Console"
import { useLocale } from "contexts/Locale"
import { Provider } from "contexts/User"
import useTopDomain from "hooks/useTopDomain"

export default function User({ children, reqcontext = {} }) {
  const console = useConsole()
  const topDomain = useTopDomain()
  const locale = useLocale()

  const ctx = {
    ...reqcontext,
    get locale() {
      return ""
    },
    set locale(code) {
      const cookie = [
        `rlx-language=${code}`,
        // `domain=${topDomain}`, // don't inculde domain to match server-side behavior
        "path=/",
        "max-age=31536000", // 1 year
        "SameSite=Strict",
      ]
        .filter(Boolean)
        .join("; ")

      console.verbose("User:locale(%s) [%s]", code, cookie)
      document.cookie = cookie
    },
    get displayCurrencyBanner() {
      return locale.current.codes.www === "en-us" && ctx.countryCode !== "US"
    }
  }

  const proxy = new Proxy(ctx, {
    get: (ctx, key) => {
      if (key === "countryCode") {
        if (locale.current.codes.www === "en-us")
          return "US"
        return ctx.countryCode
      }

      if (key === "realCountryCode")
        return ctx.countryCode

      return ctx[key]
    }
  })

  // Due to digitalDataLayer function being outside of the React component tree,
  // we need to set the locale in the global object for it to be accessible.
  if (process.browser) {
    global.__rlx ??= {}
    global.__rlx.countryCode = proxy.countryCode
  }

  console.verbose("User(%o)", ctx)
  return <Provider value={proxy}>{children}</Provider>
}
